export default {
  presets: {
    light: {
      backgroundPrimary: '#e5e8ec',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#4dc58c',
      info: '#43A047',
      danger: '#D32F2F',
      warning: '#4dc58c',
      primary: '#1b3c59',
      facebook: '#0866ff',
      gmail: '#ff4343',
      secondary: '#4ba3c3',
    },
    dark: {
      backgroundCardPrimary: '#1b3c59',
      backgroundCardSecondary: '#4ba3c3',
    },
  },
}
